<template>
  <div>
      <b-row>
        <b-colxx xxs="12">
            <b-card class="mb-4" title="">
            <b-row class="mb-5">
                <b-col xxs="12">
                    <!-- <div v-for="(popupd, idx) in popupsDetail" :key="idx"> -->
                        <div v-if="$route.query.query ==  popupsDetail.noticeNo">
                            <div class="headerNotice">
                                <div class="noticeTitle">제목 {{ popupsDetail.title }}</div>
                                <div class="name">{{ popupsDetail.registeredDate.substr(0, 10) }}</div>
                            </div>
                            <div class="noticebody" v-html="popupsDetail.contents"></div>
                            <div class="listBtnCenter">
                                <button @click="goList" class="btn btn-outline-primary">목록</button>
                            </div>
                        </div>
                    <!-- </div> -->
                </b-col>
            </b-row>
            </b-card>
        </b-colxx>
      </b-row>
      <!-- {{ $route.query }} -->
  </div>
</template>

<script>
import mixin from '../../utils/mixins';

export default {
    mixins: [mixin],
    mounted(){
        this.popupsDetailPopup(this.$route.query.query);
    },
    methods:{
        goList(){
            this.$router.push('/'+this.siteName+'/notice/NoticeList');
        }
    }
}
</script>

<style scoped>
    .noticeTitle{
        font-weight: 600;
    }
    
    .headerNotice {
        background: #f4f6f7;
        border-top: 1px solid #000;
        border-bottom: 1px solid #d4d4d4;
        padding: 10px;
        margin-bottom: 10px;
        font-size: 16px;
    }
    .noticebody {
        padding: 10px;
        font-size: 16px;
    }
    .listBtn{
        background: #777;
        border: none;
        color: #f4f6f7;
        border-radius: 3px;
        padding: 5px 20px;
        font-size: 16px;
        cursor: pointer;
    }
    .listBtnCenter{
        text-align: center;
    }
</style>